import React from 'react';

import './styles.scss';
import { format } from 'date-fns';

const SecurityReport = () => {
  const reports = [
    {
      id: 1,
      descricao: 'Exposição de informações sensíveis via headers',
      localizcao: 'headers HTTP',
      impacto: 'medio',
      observacao:
        "Adiciona os seguintes headers HTTP no servidor (IIS ou aplicação):\n\nX-Frame-Options: DENY\nX-Content-Type-Options: nosniff\nContent-Security-Policy: default-src 'self'; script-src 'self'; object-src 'none'\nCache-Control: no-store\nPermissions-Policy: camera=(), microphone=(), geolocation=()\nReferrer-Policy: no-referrer",
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
    {
      id: 2,
      descricao: 'Remoção de headers que expôem tecnologia',
      localizcao: 'headers HTTP',
      impacto: 'medio',
      observacao:
        'Oculta os headers: \nX-Powered-By:\n<system.webServer>\n<httpProtocol>\n<customHeaders>\n<remove name="X-Powered-By" />\n</customHeaders>\n</httpProtocol>\n</system.webServer>\nServer Header: usa URL Rewrite, Request Filtering ou um proxy reverso (ex: NGINX).',
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
    {
      id: 3,
      descricao: 'Vunerabilidades no formulário de login',
      localizcao: 'formulário de login',
      impacto: 'medio',
      observacao:
        'Desativar autocomplete:\n<input type="password" autocomplete="off">\n\nAdicionar token anti-CSRF com frameworks como ASP.NET MVC:\n@Html.AntiForgeryToken()\n\nProteções:\n- X-Frame-Options: DENY\n- CSP: frame-ancestors \'none\'; script-src \'self\';\n- Sanitizar inputs/HTML do utilizador',
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
    {
      id: 4,
      descricao: 'Cifragens fracas em SSL/TLS',
      localizcao: 'ssl/tls',
      impacto: 'medio',
      observacao:
        'Desativa CBC/SHA-1 no IIS com IIS Crypto.\nUsa TLS 1.2 com GCM ou TLS 1.3.',
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
    {
      id: 5,
      descricao: 'Exposição de IPs internos',
      localizcao: 'endereços IP',
      impacto: 'medio',
      observacao:
        'Evitar mostrar IPs privados (192.168.x.x, 10.x.x.x) em headers, logs ou erros.\nFiltra mensagens e usa proxy reverso.',
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
    {
      id: 6,
      descricao: "Uso inseguro de postMessage com '*'",
      localizcao: 'aplicação web',
      impacto: 'medio',
      observacao:
        "Evita o uso de '*', especifica a origem:\nwindow.postMessage(message, 'https://teusite.com.br');\n\nValida a origem ao receber:\n window.addEventListener('message', function(e){if (e.origin !== 'https://teusite.com.br') return;});",
      acao: '',
      status: 'fechado',
      dataOcorrencia: '2025-09-15',
      dataCorrecao: '2025-09-29',
    },
  ];

  return (
    <div className="security-report">
      <div className="report-title">Relatório de Segurança</div>

      <div className="report-summary">
        <span>
          Este relatório resume listagens de vulnerabilidades identificadas e
          verificadas. Cada vulnerabilidade inclui uma descrição, impacto
          potencial e data em que as ocorrências foram criadas e corrigidas.
        </span>
      </div>

      <h2>Reportes</h2>

      {/* <div className="vulnerability">
        <h3>1. Injeção de SQL (SQL Injection)</h3>
        <p>
          <strong>Localização:</strong> [Ex: Formulário de login, campo de busca
          de usuários]
        </p>
        <p>
          <strong>Descrição:</strong> O sistema falha em validar e higienizar
          corretamente as entradas do usuário, o que permite a execução de
          comandos SQL maliciosos diretamente no banco de dados.
        </p>
        <p>
          <strong>Impacto:</strong> <span className="impact-high">Alto.</span>{' '}
          Pode resultar em acesso não autorizado a dados sensíveis (informações
          de usuários, senhas hash), modificação ou exclusão de dados, e até
          mesmo controle total do banco de dados.
        </p>
        <p>
          <strong>Recomendação:</strong>
          <ul>
            <li>
              Implementar consultas parametrizadas (prepared statements) para
              todas as interações com o banco de dados.
            </li>
            <li>
              Utilizar um ORM (Object-Relational Mapper) que ofereça proteção
              contra Injeção de SQL por padrão.
            </li>
            <li>
              Garantir a validação de tipo e formato de todas as entradas de
              dados do usuário.
            </li>
          </ul>
        </p>
      </div> */}

      {reports
        .sort((a, b) => b.id - a.id)
        .map((item) => (
          <div className="vulnerability" key={item.id}>
            <div className="vulnerability-description">
              {item.id} - {item.descricao}
            </div>

            <div className="vulnerability-detail">
              <strong>Descrição:</strong>
              <span className="observacao-text">
                <div className="observacao-text-content">{item.observacao}</div>
              </span>
            </div>
            {/* <div className="">
              <span>
                <strong>Localização:</strong> {item.localizcao}
              </span>
            </div> */}
            <div className="">
              <span>
                <strong>Impacto:</strong>
                <span className="impact-medium"> {item.impacto}</span>
              </span>
            </div>
            <div className="">
              <span>
                <div className="">
                  <strong>Data ocorrência:</strong>
                  <span>
                    {' '}
                    {format(new Date(item.dataOcorrencia), 'dd/MM/yyyy')}
                  </span>
                </div>
                <div className="">
                  <strong>Data correção:</strong>
                  <span>
                    {' '}
                    {format(new Date(item.dataCorrecao), 'dd/MM/yyyy')}
                  </span>
                </div>
              </span>
            </div>

            {item.acao && (
              <div className="">
                <span>
                  <strong>Ação realizada:</strong>
                  {item.acao}
                </span>
              </div>
            )}
          </div>
        ))}

      <p>
        Todas as vulnerabilidades identificadas neste relatório foram
        corrigidas.
      </p>
    </div>
  );
};

export default SecurityReport;
